import benefit from 'assets/images/benfefit.png'
import { TextParagraph } from 'theme/components/text'

const benefits = [
  'Scalable to all human',
  'Built on the Worldchain',
  'Secured by Ethereum',
  'Multiple tokens supported',
]

export function BenefitSection() {
  return (
    <section className="bg-bg2 w-full py-5 lg:py-[100px]">
      <div className="px-5 xl:px-[160px] 2xl:px-[220px] flex flex-col lg:flex-row items-stretch justify-between lg:gap-[160px]">
        <div className="flex flex-row lg:flex-col items-center lg:items-start justify-between">
          <TextParagraph size="sm" className="whitespace-nowrap">
            WORLD SWAP
          </TextParagraph>

          <div className="w-[118px] lg:w-[222px]">
            <img src={benefit} alt="benefit" width={692} height={843} loading="lazy" />
          </div>
        </div>

        <ul className="flex-1">
          {benefits.map((item) => (
            <li key={item} className="text-lg">
              <TextParagraph size="large" variant="light12" className="py-2.5">
                {item}
              </TextParagraph>

              <div className="w-full h-[1px] bg-[#96DFEB] my-2.5" />
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
